var numberWithCommas = function(x, grouping, groupingSeparator, decimalSeparator) {
    var parts = x.toString().split(".");
    var regex = new RegExp("\\B(?=(\\d{" + grouping + "})+(?!\\d))", "g");
    // grouping separator
    parts[0] = parts[0].replace(regex, groupingSeparator);
    // decimal separator
    return parts.join(decimalSeparator);
}

export default function(value, currencyCode, negationNeeded, ignorePrefixSuffix, ignoreGrouping){
  if(window.currency_list && window.currency_list[currencyCode]) {
    var format = window.currency_list[currencyCode];
    var maximumFractionDigits = format.maximumFractionDigits;
    var moneyValue = ((negationNeeded ? -1 : 1 )  * value) / (10 ** maximumFractionDigits);
    var moneyValuePositive = value / (10 ** maximumFractionDigits);
    var roundedValue = Number(Math.round(moneyValuePositive * (10 ** maximumFractionDigits)) / (10 ** maximumFractionDigits)).toFixed(maximumFractionDigits);
    /*
      TODO check if this can be used
      Number.prototype.round = function(places) {
        return +(Math.round(this + "e+" + places)  + "e-" + places);
      }
    */
    if(!ignoreGrouping && format.groupingUsed) {
      var output = numberWithCommas(roundedValue, format.groupingSize, format.decimalFormatSymbols.groupingSeparator, format.decimalFormatSymbols.monetaryDecimalSeparator);
    }
    else {
      var output = roundedValue;
    }

    if(ignorePrefixSuffix) {
      return output;
    }

    if(moneyValue >= 0) {
      return format.positivePrefix + output + format.positiveSuffix;
    }
    else {
      return format.negativePrefix + output + format.negativeSuffix;
    }
  }
  else {
    return currencyCode && new Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode }).format(value / 100.0);
  }
}


// WEBPACK FOOTER //
// ./src/filters/currency.js